import cs from 'classnames';
import React from 'react';
import { injectV2 } from '../../injectV2';
import { HeaderSearch } from '../HeaderSearch/HeaderSearch';
import { HeaderStore } from '../../stores/HeaderStore';
import { RoutingStore } from '../../stores/RoutingStore';
import { WithTranslations, withTranslations } from '../../../utils/withTranslations';
import { ExperimentsStore } from '../../../stores/ExperimentsStore';
import styles from './HeaderTitle.scss';
import { headerTitleDataHooks } from './HeaderTitle.dataHooks';

interface HeaderTitleProps extends WithTranslations {
  children?: React.ReactNode;
  dataHook?: string;
  focusOnSubTitle?: () => void;
  headerStore: HeaderStore;
  routingStore: RoutingStore;
  experimentsStore: ExperimentsStore;
}

const HeaderTitleCmp: React.FC<HeaderTitleProps> = ({
  t,
  dataHook,
  headerStore,
  routingStore,
  experimentsStore,
  focusOnSubTitle,
}) => {
  const HeadingTagName = routingStore.matchedRoute.routeName === 'home' ? 'h1' : 'div';
  const isTitleStartCreating = experimentsStore.is(
    'specs.abTranslate.marketing.templatesGallery.web.abSpec-titleStartCreating',
    '1',
  );
  return (
    <div className={styles.container} data-hook={dataHook}>
      <HeadingTagName
        className={cs(styles.title, { [styles.smallerText]: isTitleStartCreating })}
        data-hook={headerTitleDataHooks.title()}
      >
        {t('header.title')}
      </HeadingTagName>
      {!headerStore.isSticky && (
        <HeaderSearch dataHook={headerTitleDataHooks.search()} focusOnSubTitle={focusOnSubTitle} />
      )}
    </div>
  );
};

export const HeaderTitle = withTranslations(
  injectV2('headerStore', 'routingStore', 'experimentsStore')(HeaderTitleCmp),
);
